import { SeButton } from '../se-button/se-button';
import { customElement } from 'lit/decorators.js';

/**
 * The SeSplitButton component
 * @element se-split-button
 */
@customElement('se-split-button')
export class SeSplitButton extends SeButton {}

declare global {
  interface HTMLElementTagNameMap {
    'se-split-button': SeSplitButton;
  }
}
